import followersActions from "./followers/actions"
import followingActions from "./following/actions"
import ApiService from "@/base/api/api.service"
import router from "@/router"

import {
    GET_PROFILE_URL,
    GET_USER_URL
} from "@/base/api/config";


import {
    GET_CURRENT_USER,
    GET_PROFILE_POST_LIST,
    GET_PROFILE_SAVED_POST_LIST,
    CLEAR_CURRENT_PROFILE_RELATED,
    FOLLOW_USER,
    UNFOLLOW_USER
} from "@/store/actions.type"

import {
    SET_CURRENT_PROFILE,
    SET_PROFILE_LOADING,
    SET_PROFILE_POST_LIST_LOADING,
    SET_PROFILE_SAVED_POST_LIST_LOADING,
    SET_ERROR,
    CLEAR_CURRENT_PROFILE,
    PUSH_PROFILE_POST,
    PUSH_SAVED_PROFILE_POST
} from "@/store/mutations.type"

export default {
    async [GET_CURRENT_USER]({ commit }, payload) {
        commit(SET_PROFILE_LOADING, true)
        try {
            const res = await ApiService.get(GET_PROFILE_URL, `${payload.username}`)
            commit(SET_PROFILE_LOADING, false)
            commit(SET_CURRENT_PROFILE, { ...res.data.user })
        } catch (err) {
            commit(SET_PROFILE_LOADING, false)
            router.push('/not-found/')
        }
    },


    [CLEAR_CURRENT_PROFILE_RELATED]({ commit }) {
        commit(CLEAR_CURRENT_PROFILE) // Clearing the profile
    },

    // Getting Profile post list 
    [GET_PROFILE_POST_LIST]({ commit, state }, payload) {
        commit(SET_PROFILE_POST_LIST_LOADING, true)
        ApiService.get(GET_PROFILE_URL, `${payload.profileId}/post/list?offset=${state.profilePostListOffset}&limit=${state.profilePostListLimit}`)
            .then(res => {
                commit(SET_PROFILE_POST_LIST_LOADING, false)
                commit(PUSH_PROFILE_POST, res.data.posts)
            })
            .catch(err => {
                commit(SET_PROFILE_POST_LIST_LOADING, false)
                commit(SET_ERROR, err.data)
            })
    },

    // Getting Profile saved post list 
    [GET_PROFILE_SAVED_POST_LIST]({ commit, state }) {
        commit(SET_PROFILE_SAVED_POST_LIST_LOADING, true)
        ApiService.get(GET_USER_URL, `bookmarks?offset=${state.profileSavedPostListOffset}&limit=${state.profilePostListLimit}`)
            .then(res => {
                commit(SET_PROFILE_SAVED_POST_LIST_LOADING, false)
                commit(PUSH_SAVED_PROFILE_POST, res.data.posts)
            })
            .catch(err => {
                commit(SET_PROFILE_SAVED_POST_LIST_LOADING, false)
                commit(SET_ERROR, err.data)
            })
    },

    // Follow user
    async [FOLLOW_USER]({ commit }, payload) {
        try {
            await ApiService.post(`${GET_USER_URL}/${payload.userId}/follow`)
        } catch (err) {
            commit(SET_ERROR, err.data)
        }
    },

    // Unfollow uesr
    async [UNFOLLOW_USER]({ commit }, payload) {
        try {
            await ApiService.delete(`${GET_USER_URL}/${payload.userId}/unfollow`)
        } catch (err) {
            commit(SET_ERROR, err.data)
        }
    },

    ...followersActions,
    ...followingActions
}